import FormMultiSelect from "component/form/form_multi_select";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { defaultSupporterInfoSelector } from "store/user/(default)/supporter/default_supporter.selector";
import { SUPPORTER_PERMISSIONS } from "store/string";

//
//component
//redux
//selector
//actions
//utils
//hook
//str

const SupporterPermissions = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const supporterInfo = useSelector(defaultSupporterInfoSelector);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!supporterInfo) return null;
  return (
    <FormMultiSelect
      label="Cấp quyền khách hàng"
      options={SUPPORTER_PERMISSIONS}
      name="supporters"
      rules={[{ required: true, message: "Điền thông tin đầy đủ" }]}
      placeholder="Quyền truy cập khách hàng"
    />
  );
};
export default SupporterPermissions;
